import styled from 'styled-components';

export const ArrowLinkIconContainer = styled.div`
  display: inline-flex;
  padding-left: 1em;
  vertical-align: middle;
`;
